//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ProductCardPublicationStatus {
  NotPublished = 0,
  Processing = 1,
  Moderating = 2,
  Published = 3,
  ApiError = 4,
  SuccessImport = 5
}
